import React from 'react';
import './Footer.scss';
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="max-1000">
            <ul>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <a rel="noopener noreferrer" target="_blank" href="https://linkedin.com/in/mikogonzaga">LinkedIn</a>
                </li>
            </ul>
        </footer>
    )
}
